export enum SensitiveLabelsPlatform {
  mip = 'mip',
}

export interface SensitiveLabelEntity {
  id: string;
  name: string;
}

export interface SensitiveLabelsResponse {
  labels: Record<SensitiveLabelsPlatform, SensitiveLabelEntity[]>;
}
